module.exports = __webpack_public_path__ + "3844c3db3e749d7ac3a04950683a390e.MP3";